import { useMemo } from 'react'

import { TeamRole } from '@/consts/team'
import { TeamFSContext } from '@/pages/data-mgr/core/context'
import { useDeleteCore } from '@/pages/data-mgr/core/hooks/useDelete'

export function useTeamDelete(userRole: TeamRole, teamId: number) {
  const context = useMemo(() => new TeamFSContext(userRole, teamId), [userRole, teamId])
  return useDeleteCore(context)
}
